import React, { useState } from 'react';
import '../styles/ContactSection.css';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    telephone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ success: null, message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ success: null, message: '' });
    
    try {
      const response = await fetch('https://fauconbleu.ma/api/lgm/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(formData)
      });
      
      if (response.ok) {
        setSubmitStatus({ 
          success: true, 
          message: 'Votre message a été envoyé avec succès!' 
        });
        setFormData({ nom: '', email: '', telephone: '', message: '' });
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Une erreur est survenue');
      }
    } catch (error) {
      setSubmitStatus({ 
        success: false, 
        message: error.message || 'Une erreur est survenue. Veuillez réessayer.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="Contact-form" className="contact-section" >
      <div className="contact-background"></div>
      
      <div className="contact-container">
        <div className="contact-form-container">
          {submitStatus.success && (
            <div className="submit-status success">
              {submitStatus.message}
            </div>
          )}
          
          {submitStatus.success === false && (
            <div className="submit-status error">
              {submitStatus.message}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="nom">Nom</label>
              <input 
                type="text" 
                id="nom" 
                name="nom" 
                value={formData.nom}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="telephone">Téléphone</label>
                <input 
                  type="tel" 
                  id="telephone" 
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea 
                id="message" 
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="6"
                required
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'ENVOI EN COURS...' : 'ENVOYER'}
            </button>
          </form>
        </div>
        
        <div className="contact-info">
          <h2>Nous contacter</h2>
          
          <p>
            Vous avez un projet ou une question ?<br />
            Contactez LGM, distributeur exclusif<br />
            LiuGong au Maroc — notre équipe est à<br />
            votre écoute.
          </p>
          
          <div className="contact-details">
            <div className="contact-item">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="#00307d">
                  <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
                </svg>
              </div>
              <div className="contact-text">
                <h4>Phone</h4>
                <p>00 212 6 68 63 23 87</p>
              </div>
            </div>
            
            <div className="contact-item">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="#00307d">
                  <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
                </svg>
              </div>
              <div className="contact-text">
                <h4>Email</h4>
                <p>info@lgm.ma</p>
                <p>Commercial@lgm.ma</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;